import { ALERTS_STATE } from './constants'
import type { IAlertType } from './types'

export interface IAlertsState {
  [ALERTS_STATE]: IAlertType[]
}

const state: IAlertsState = {
  [ALERTS_STATE]: [],
}

export default state
